import { IEditVehiclePayload, IGetVehicleList, IVehicleCreate, IVehicleDetails, IVehicleListSearch } from "../../../types/master/vehicleInterface";
import { VehicleActionTypes, VehicleActions } from "../../actionTypes/master/vehicleActionTypes";


export const createVehicle = (payload: IVehicleCreate): VehicleActionTypes => ({
  type: VehicleActions.CREATE_VEHICLE,
  payload,
});

export const getVehicleList = (payload: IVehicleListSearch): VehicleActionTypes => ({
  type: VehicleActions.GET_VEHICLE_LIST,
  payload,
});

export const setVehicleList = (branchList: Array<IGetVehicleList>) : VehicleActionTypes => ({
  type: VehicleActions.SET_VEHICLE_LIST,
  payload: branchList
})

export const setVehicleListPageCount = (payload:number): VehicleActionTypes => ({
  type: VehicleActions.SET_VEHICLE_LIST_PAGE_COUNT,
  payload
})

export const getVehicleDataById = (id: number | string): VehicleActionTypes => ({
  type: VehicleActions.GET_VEHICLE_DATA_BY_ID,
  payload: id
})

export const setVehicleDataById = (payload: IVehicleDetails) => ({
  type: VehicleActions.SET_VEHICLE_DATA_BY_ID,
  payload
})

export const editVehicle = (payload: IEditVehiclePayload) => ({
  type: VehicleActions.EDIT_VEHICLE_DATA_BY_ID,
  payload,
});
